import React from "react";
import HeroBannerDynamic from "./hero-banner-dynamic.component";

const HeroBanner = () => {
  return <HeroBannerDynamic />;
};
export default HeroBanner;
